/**
 * @ngdoc directive
 * @name couponsearch
 *
 * @description
 * Coupon search component
 */
module.directive('couponsearch', function() {
    'use strict';
    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            order: '=',
            labels: '=', /* {label:'', placeholder:'', info: ''} */
            disabled: "=?"
        },
        controller: ['$scope', 'drupal', '$rootScope', function($scope, $drupal, $rootScope) {
            $scope.form = {
                couponId: "",
                message: "", /* error message */
                pending: false,
                list: []
            };

            $scope.searchCoupon = function () {
                if (!$scope.form.pending && $scope.form.couponId) {
                    $scope.form.pending = true;
                    $drupal.applyCoupon($scope.form.couponId).then(function () {
                        $rootScope.$broadcast("couponApplied", $scope.form.couponId);
                    }).catch(function(result) {
                        var data = result.data;
                        if (typeof data !== 'undefined') {
                            if (typeof data !== 'undefined' && data.display === true) {
                              swal({
                                title: 'Code promo',
                                text: data.message,
                                icon: 'warning'
                              });
                            }
                        }
                    }).finally(function() {
                        $scope.form.couponId = '';
                        $scope.form.pending = false;
                    });
                }
            };
        }],
        templateUrl: 'src/components/couponsearch/couponsearch.html'
    };
});
